var _excluded = ["children", "classes", "className", "value"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { findChildrenByType } from "../internals/utils/reactHelpers";
import { normalizeClassnames } from "../internals/utils/classNameHelpers";
import SovosTab from "../sovos-tab";
var StyledTabs = styled(Tabs)(function (_ref) {
  var _ref2;
  var spacing = _ref.theme.spacing;
  var height = spacing(6);
  return _ref2 = {
    backgroundColor: 'transparent',
    height: height
  }, _defineProperty(_ref2, "& .".concat(tabsClasses.indicator), {
    height: spacing(0.5)
  }), _defineProperty(_ref2, "& .".concat(tabsClasses.scrollButtons), {
    flex: "0 0 ".concat(spacing(3))
  }), _ref2;
});

/**
 * This component can be used with `SovosTab` to render a tab bar. However,
 * `SovosTabContents` and `SovosTabGroup` will generate tabs and handle tab
 * switching and should be used in most situations.
 */
export var SovosTabs = function SovosTabs(_ref3) {
  var children = _ref3.children,
    classes = _ref3.classes,
    className = _ref3.className,
    value = _ref3.value,
    other = _objectWithoutProperties(_ref3, _excluded);
  var tabs = findChildrenByType(children, Tab, SovosTab);
  return /*#__PURE__*/React.createElement(StyledTabs, _extends({
    classes: classes,
    className: clsx('sovosTabs', className),
    variant: "scrollable",
    value: value,
    textColor: "primary",
    indicatorColor: "primary"
  }, other), tabs.map(function (tab) {
    return /*#__PURE__*/React.cloneElement(tab, {
      className: clsx('sovosTabs__tab--label', "sovosTabs__tab--label-".concat(normalizeClassnames(tab.props.value)), tab.props.className)
    });
  }));
};
SovosTabs.propTypes = {
  /**
   * Content of the tabs. Must be an array of Mui `Tab` or `SovosTab`
   */
  children: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  classes: PropTypes.object,
  /**
   * Extend the class name applied to the root element
   */
  className: PropTypes.string,
  /**
   * The value of the currently selected tab
   */
  value: PropTypes.any,
  /**
   * Callback fired when the selected tab changes
   *
   * `function(event: object, value: object) => void`
   */
  onChange: PropTypes.func.isRequired
};
SovosTabs.baseComponent = {
  name: 'Tabs',
  link: 'tabs/'
};
export default SovosTabs;